import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const IntegrationsSalesForceIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "IntegrationsSalesForce",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M13.66 8.36c.42-.43.91-.78 1.46-1.04h.03a4.6 4.6 0 0 1 2.02-.45c1.77 0 3.31.94 4.18 2.34v.02c.09.14.16.16.32.1.67-.28 1.46-.45 2.28-.45 3.34 0 6.05 2.71 6.05 6.05 0 2.99-2.17 5.48-5.02 5.97h-.04c-.3.06-.65.09-1 .09s-.7-.03-1.04-.09h.04-.06c-.08 0-.15.05-.18.11a4.38 4.38 0 0 1-3.74 2.1h-.21c-.56-.01-1.08-.13-1.56-.34l-.17-.06c-.17.29-.32.59-.51.85a4.89 4.89 0 0 1-4.06 2.17c-.25 0-.49-.02-.73-.05h.03a4.88 4.88 0 0 1-4.01-2.95v-.03c-.08-.14-.13-.19-.3-.16-.22.04-.47.06-.72.06C4.11 22.6 2 20.49 2 17.88c0-1.24.48-2.37 1.26-3.21.31-.32.66-.59 1.01-.88a5.3 5.3 0 0 1-.4-2.06c0-2.02 1.1-3.79 2.73-4.73h.03c.78-.46 1.71-.72 2.7-.72 1.75 0 3.31.81 4.33 2.08s0 .01 0 .01Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M8.67 5a6.675 6.675 0 0 0-6.38 8.62A5.96 5.96 0 0 0 0 18.34c0 3.51 3.06 6.34 6.61 5.97 1 2.03 3.1 3.36 5.39 3.36 2.14 0 4.11-1.15 5.18-2.97a5.61 5.61 0 0 0 6.65-2.41c.29.04.56.05.83.05 4.04 0 7.33-3.29 7.33-7.33s-3.29-7.33-7.33-7.33c-.82 0-1.61.13-2.38.4a5.69 5.69 0 0 0-4.62-2.4c-1.51 0-2.92.58-3.97 1.63a6.64 6.64 0 0 0-5.03-2.29Z"
      })
    })
  }));
};
IntegrationsSalesForceIcon.displayName = 'IntegrationsSalesForceIcon';